export default __webpack_public_path__ + "static/media/more(2).e048a5c6.svg";